import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=558d6760&scoped=true&"
import script from "./PasswordReset.ts?vue&type=script&lang=ts&"
export * from "./PasswordReset.ts?vue&type=script&lang=ts&"
import style0 from "./PasswordReset.css?vue&type=style&index=0&id=558d6760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d6760",
  null
  
)

export default component.exports